import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
import { NumberCountWrapper } from '../../../common/NumberCount'
const VisitCard = observer(() => {
  const content = ContentState
  const list = content.about?.firstscreen?.list

  return (
    <section className="visit-card">
      <div className="visit-card__container">
        <h1
          className="visit-card__title"
          dangerouslySetInnerHTML={{
            __html: content.about?.firstscreen?.title,
          }}
        ></h1>
        <div className="visit-card__list">
          {list?.slice(0, 4).map((li: any, i: number) => {
            const num = li.num?.match(/([\d\.\,])/g)
            const number = num.join('')
            const indexStart = li.num.indexOf(number)
            const indexEnd = indexStart + number.length
            const end = indexStart == -1 ? '' : li.num.slice(indexEnd)

            return (
              <div className="visit-card__item" key={i}>
                <div className="we-block__item-num">
                  <NumberCountWrapper
                    final={+number.replaceAll(',', '.')}
                    end={end}
                  />
                </div>
                <div
                  className="visit-card__item-text"
                  dangerouslySetInnerHTML={{ __html: li.text }}
                ></div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
})

export default VisitCard
